import { useEffect, useRef, useState } from "react";
import { MainContainer } from "../../components/Contents/Contents.element";
import IApiResponse from "../../types/IApiResponse";
import { IClubCardDetail } from "../../types/IClubDetail";
import { fetchData, postData } from "../../services/api";
import apiUrls from "../../config/apiUrls";
import handleApiResponse from "../../utils/handleApiResponse";
import {
  PlayerCardData,
  PlayerClubCountryInfoData,
  PlayerClubInfoData,
  PlayerContent,
  PlayerLargeDataText,
  PlayerLargeDataValue,
} from "../../styled-components/PlayerCard.Styles";
import noImageClub from "../../assets/icons/noImageClub.svg";
import { useTheme } from "../../contexts/ThemeContext";
import LabelText from "../../ui/LabelText";
import { TabSectionStyles } from "../../styled-components/TabStyles";
import CustomTabs from "../../ui/Tab";
import { ITab } from "../../types/ITab";
import { SquadTab } from "../../components/ClubDetail/Squad/SquadTab";
import ClubFinancial from "../../components/ClubDetail/ClubFinancial/ClubFinancial";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../ui/LoadingSpinner";
import { useLoading } from "../../contexts/LoadingContext";
import { useAuth } from "../../contexts/AuthContext";

const Presentation: React.FC<{ toggle: boolean; isSubSidebarOpen: boolean }> = (props) => {
  const { presentId } = useParams<{ presentId: string }>();
  const [activeTab, setActiveTab] = useState<string>("Squad");
  const {loading, startLoading, stopLoading } = useLoading()
  const [clubData, setClubData] = useState<IClubCardDetail>();
  const [isScroll, setIsScroll] = useState<boolean>(false);
  const [clubs, setClubs] = useState<{ key: string; title: string }[]>([]);
  const [teamId, setTeamId] = useState<string>(clubs[0]?.key);
  const stickyRef = useRef<HTMLDivElement | null>(null);
  const { theme } = useTheme();
  // const {allowPresentaion} = useAuth()
  const navigate = useNavigate()
  const TABS: ITab[] = [
    { title: "Squad", key: "Squad" },
    { title: "Financial", key: "Financial" },
  ];
  const onScroll = () => {
    if (stickyRef.current) {
      const { scrollTop } = stickyRef.current;
      if (scrollTop > 275) {
        if (!isScroll) {
          setIsScroll(true);
        }
      } else {
        setIsScroll(false);
      }
    }
  };
  const allowPresentaion = localStorage.getItem('allowPresentation') === 'true';
  navigate(allowPresentaion ? "/presentation/leeds" : "/home")
  useEffect(() => {
    
    const fetchClubsForPresentation = async () => {
      startLoading();
      try {
        const ApiRequestData = {
          id: presentId,
        };
        const response: IApiResponse<any[]> = await postData(apiUrls.GetTeamsForPresentation, ApiRequestData);
        handleApiResponse(
          response,
          (clubsForPresentation) => {
            stopLoading()
            const filteredClubs = clubsForPresentation.map(club => ({key: club.id.toString(), title: club.name}))
            setClubs(filteredClubs);
            setTeamId(filteredClubs[0].key);
          },
          (error) => {
            // stopLoading()
            console.error(error);
          }
        );
      } catch (error) {
        stopLoading()
        console.error("Error fetching player card data:", error);
      }
    };
    if (clubs?.length === 0) {
        fetchClubsForPresentation();
    }
    
  }, []);


  useEffect(() => {
    const mainContainer = stickyRef.current!;
    if (mainContainer) {
      mainContainer.addEventListener("scroll", onScroll);
      return () => {
        mainContainer.removeEventListener("scroll", onScroll);
      };
    }
   
  }, []);


  useEffect(() => {
    const fetchClubData = async () => {
      const requestParameters = {
        TeamId : teamId
      };
      const response: IApiResponse<IClubCardDetail> = await postData(apiUrls.GetTeamCardDetails, requestParameters);
      handleApiResponse(
        response,
        (teamsData) => {
          setClubData(teamsData);
        },
        (error) => {
          console.error("Error fetching club card Data:", error);
        }
      );
    };
    fetchClubData();
  }, [teamId]);

  const handleTabClick = (key: string) => {
    setActiveTab(key);
  };
  const handleTeamChange = (key: string) => {
    setTeamId(key);
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case "Financial":
        return <ClubFinancial team={teamId!} />;
      case "Squad":
        return <SquadTab teamId={teamId!} />;
      default:
        return null;
    }
  };

  return (
    <MainContainer ref={stickyRef} active={props.toggle} isSubSidebarOpen={props.isSubSidebarOpen} className="main-container">
      <div className="presentation-tab-section">
        <CustomTabs tabs={clubs} activeTabKey={teamId} onTabClick={handleTeamChange} />
      </div>
      {isScroll && (
        <div className="presentation-sticky-club-bar">
          <img src={clubData?.teamLogoURL} alt="club-image" height={48} width={48} />
          <LabelText className="player-detail-given-name">{clubData?.teamName}</LabelText>
        </div>
      )}
      {clubData && <>
        <div className="presentation-club-data-main">
            <div className="presentation-club-card">
            <div className="player-card-detail">
                <div className="player-header">
                <img src={clubData?.teamLogoURL ? clubData?.teamLogoURL : noImageClub} alt="club-image" />
                </div>
                <div className="player-name-header">
                <LabelText className="player-detail-given-name" style={{ color: theme.NumberColor }}>
                    {clubData?.competitionName}
                </LabelText>
                <div className="player-name-squad" style={{ paddingTop: "0px" }}>
                    <LabelText className="player-detail-family-name">{clubData?.teamName}</LabelText>
                </div>
                <div className="player-clubInfo" style={{ paddingLeft: "0px" }}>
                    <PlayerClubCountryInfoData>
                    <PlayerClubInfoData country="country" className="player-descriptive-data">
                        <PlayerLargeDataText className="descriptive-text">Country</PlayerLargeDataText>
                        <PlayerLargeDataValue className="descriptive-value">{clubData?.countryName}</PlayerLargeDataValue>
                    </PlayerClubInfoData>
                    <img src={`/assets/country_flags/${clubData?.countryCode || ""}.svg`} alt="Country Flag" className="country-image" />
                    </PlayerClubCountryInfoData>
                    <PlayerClubInfoData className="player-descriptive-data">
                    <PlayerLargeDataText className="descriptive-text">League Pos</PlayerLargeDataText>
                    <PlayerLargeDataValue className="descriptive-value">{clubData?.currentLeaguePosition}</PlayerLargeDataValue>
                    </PlayerClubInfoData>
                    <PlayerClubInfoData className="player-descriptive-data">
                    <PlayerLargeDataText className="descriptive-text">Highest wage pw</PlayerLargeDataText>
                    <PlayerLargeDataValue className="descriptive-value">€{clubData?.highestWageText}</PlayerLargeDataValue>
                    </PlayerClubInfoData>
                    <PlayerClubInfoData className="player-descriptive-data">
                    <PlayerLargeDataText className="descriptive-text">Average wage pw</PlayerLargeDataText>
                    <PlayerLargeDataValue className="descriptive-value">€{clubData?.averageWageText}</PlayerLargeDataValue>
                    </PlayerClubInfoData>
                </div>
                </div>
            </div>
            </div>
        </div>
        <PlayerContent className={activeTab === "Squad" ? "club-tab-main" : "main-player-container-new"}>
            <TabSectionStyles className="tab-section" style={{ top: "145px" }}>
            <CustomTabs tabs={TABS} activeTabKey={activeTab} onTabClick={handleTabClick} />
            </TabSectionStyles>
            {renderTabContent()}
        </PlayerContent>
      </>}
      {loading && <LoadingSpinner />}
    </MainContainer>
  );
};

export default Presentation;
